import classNames from 'classnames';
import { each } from 'lodash';
import React from 'react';
import ReactTooltip from 'react-tooltip';
import './versions.scss';


class Versions extends React.PureComponent {
  componentDidMount() {
    ReactTooltip.rebuild();
  }

  render() {
    const { versions, versionNumber, versionsExpanded, isPlaying, clickHandler, versionsExpandedHandler } = this.props;
    const versionItems = [];

    each(versions, (version, versionKey) => {
      const count = versionKey + 1;
      if ( !versionsExpanded || versionNumber === count ) {
        versionItems.push(<li
          key={count}
        ><span
          className={classNames({
            playing: isPlaying && versionNumber === count,
            [`versionNumber${count}`]: true,
          })}
          onClick={() => {
            if (!versionsExpanded) {
              versionsExpandedHandler();
            }
            setTimeout(() => {
              clickHandler(count);
            }, 0);
          }}
          data-tip={version.hifi_song_version_title}
        >{count}</span></li>);
      }
    });

    return (
      <ul className="versions">
        {versionItems}
      </ul>
    );
  }
}

export default Versions;
